import { useInfoCenterPublic } from '@content-api/provider';
import { Typography, Checkbox } from '@ui/components';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

export interface TopUpWireTransferProps {
  checked?: boolean;
  costCenterAccountNumber?: string;
  onCheckedChange: (checked: boolean) => void;
}

export const TopUpWireTransfer: FC<TopUpWireTransferProps> = ({
  checked = false,
  costCenterAccountNumber,
  onCheckedChange,
}) => {
  const { t } = useTranslation();

  const { getContactUs } = useInfoCenterPublic();
  const { data: contactUs } = useQuery({
    queryKey: ['content-api', 'contact-us'],
    queryFn: () => getContactUs(),
  });

  return (
    <div className="flex flex-col gap-8">
      <div className="flex items-center gap-2">
        <Checkbox
          onCheckedChange={(state) => onCheckedChange(state === true)}
          name="wire-transfer"
          id="wire-transfer"
          checked={checked}
        />
        <Typography variant="labelMediumMedium" asChild>
          <label htmlFor="wire-transfer">{t('ONBOARDING.TOP_UP.WIRE_TRANSFER')}</label>
        </Typography>
      </div>
      {checked && (
        <div className="space-y-2">
          <Typography variant="labelSmallBook" className="text-weak" element="h6">
            {t('ONBOARDING.TOP_UP.TRANSFER_INFO_HEADER')}
          </Typography>
          {costCenterAccountNumber ? (
            <div className="flex flex-col gap-2">
              <Typography className="whitespace-nowrap" variant="labelMediumBook">
                {t('ONBOARDING.TOP_UP.WIRE_TRANSFER_INFO_LINE_1', {
                  address: contactUs?.data.address,
                })}
              </Typography>
              <Typography variant="labelMediumBook" element="span">
                {t('ONBOARDING.TOP_UP.WIRE_TRANSFER_INFO_LINE_2', { costCenterAccountNumber })}
              </Typography>
              <Typography variant="labelMediumBook" element="span">
                {t('ONBOARDING.TOP_UP.WIRE_TRANSFER_INFO_LINE_3')}
              </Typography>
            </div>
          ) : (
            <Typography variant="labelMediumBook">
              {t('ONBOARDING.TOP_UP.ACCOUNT_NUMBER_NOT_READY_YET')}
            </Typography>
          )}
        </div>
      )}
    </div>
  );
};
